module.exports = __webpack_public_path__ + "img/9788937454561.b9107ab8.jpg";